'use client';

import { Fragment, useEffect, useState } from 'react';
import styles from './event-hero.module.scss';

type TimeLeft = { days: number; hours: number; minutes: number; seconds: number };

function getTimeLeft(targetDate: Date): TimeLeft {
  const diff = Math.max(0, targetDate.getTime() - Date.now());
  const s = Math.floor(diff / 1000);
  return {
    days: Math.floor(s / 86400),
    hours: Math.floor((s % 86400) / 3600),
    minutes: Math.floor((s % 3600) / 60),
    seconds: s % 60,
  };
}

export const EventHeroCountdown = ({ eventDate }: { eventDate: string }) => {
  const target = new Date(eventDate);
  const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(null);
  const [isPast, setIsPast] = useState(false);

  useEffect(() => {
    const update = () => {
      if (Date.now() >= target.getTime()) {
        setIsPast(true);
        return;
      }
      setTimeLeft(getTimeLeft(target));
    };

    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventDate]);

  if (isPast || !timeLeft) return null;

  const units = [
    { label: 'Days', value: timeLeft.days },
    { label: 'Hours', value: timeLeft.hours },
    { label: 'Minutes', value: timeLeft.minutes },
    { label: 'Seconds', value: timeLeft.seconds },
  ];

  return (
    <div className={styles.countdown_card}>
      <div className={styles.countdown_label_wrap}>
        <p className={styles.countdown_label}>Event starts in:</p>
      </div>

      <div className={styles.countdown_label_divider} aria-hidden />

      <div className={styles.countdown_units} aria-live="off" aria-atomic="true">
        {units.map((unit, i) => (
          <Fragment key={unit.label}>
            {i > 0 && <div className={styles.countdown_v_divider} aria-hidden />}
            <div className={styles.countdown_unit}>
              <span className={styles.countdown_number}>{String(unit.value).padStart(2, '0')}</span>
              <span className={styles.countdown_unit_label}>{unit.label}</span>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};
